import { FaTimes, FaPlay, FaArrowRight } from "react-icons/fa";

export default function DemoModal({
  open,
  onClose,
  form,
  onChange,
  onSubmit,
  onWhatsApp,
  loading = false,
  error = null,
  success = null,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-slate-950/80 p-3 backdrop-blur-md sm:p-4">
      <div
        className="
          relative flex max-h-[95vh] w-full max-w-lg flex-col overflow-y-auto
          rounded-2xl border border-white/10 bg-slate-900 p-4 shadow-2xl
          sm:max-h-[90vh] sm:rounded-3xl sm:p-8
        "
      >
        {/* CLOSE */}
        <button
          type="button"
          onClick={onClose}
          aria-label="Close demo form"
          className="
            absolute right-3 top-3 flex h-10 w-10 items-center justify-center
            rounded-xl bg-white/5 text-slate-400 transition
            hover:bg-white/10 hover:text-white sm:right-5 sm:top-5
          "
        >
          <FaTimes />
        </button>

        {/* ICON */}
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-500/10 text-lg text-emerald-400 sm:h-12 sm:w-12 sm:rounded-2xl sm:text-xl">
          <FaPlay />
        </div>

        {/* TITLE */}
        <h2 className="mt-4 pr-10 text-xl font-black text-white sm:mt-6 sm:text-2xl">
          See Muyaz Business OS in action.
        </h2>

        <p className="mt-2 text-sm leading-relaxed text-slate-400 sm:mt-3">
          Tell us a little about your business, or chat with us directly on
          WhatsApp.
        </p>

        <form onSubmit={onSubmit} className="mt-4 space-y-3 sm:space-y-4">
          {/* FULL NAME */}
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-slate-400 sm:mb-2">
              Full Name
            </label>
            <input
              name="fullName"
              required
              value={form.fullName}
              onChange={onChange}
              placeholder="Enter your full name"
              className="w-full rounded-xl border border-white/10 bg-slate-950 px-3.5 py-3 text-sm text-white outline-none transition placeholder:text-slate-600 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 sm:px-4"
            />
          </div>

          {/* BUSINESS NAME */}
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-slate-400 sm:mb-2">
              Business Name
            </label>
            <input
              name="businessName"
              value={form.businessName}
              onChange={onChange}
              placeholder="Your business name"
              className="w-full rounded-xl border border-white/10 bg-slate-950 px-3.5 py-3 text-sm text-white outline-none transition placeholder:text-slate-600 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 sm:px-4"
            />
          </div>

          {/* EMAIL */}
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-slate-400 sm:mb-2">
              Email Address
            </label>
            <input
              name="email"
              type="email"
              required
              value={form.email}
              onChange={onChange}
              placeholder="you@company.com"
              className="w-full rounded-xl border border-white/10 bg-slate-950 px-3.5 py-3 text-sm text-white outline-none transition placeholder:text-slate-600 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 sm:px-4"
            />
          </div>

          {/* PHONE */}
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-slate-400 sm:mb-2">
              Phone Number
            </label>
            <input
              name="phone"
              type="tel"
              required
              value={form.phone}
              onChange={onChange}
              placeholder="0900 000 000"
              className="w-full rounded-xl border border-white/10 bg-slate-950 px-3.5 py-3 text-sm text-white outline-none transition placeholder:text-slate-600 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 sm:px-4"
            />
          </div>

          {/* BUSINESS TYPE */}
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-slate-400 sm:mb-2">
              Business Type
            </label>
            <select
              name="type"
              required
              value={form.type}
              onChange={onChange}
              className="w-full rounded-xl border border-white/10 bg-slate-950 px-3.5 py-3 text-sm text-white outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 sm:px-4"
            >
              <option value="">Select business type</option>
              <option value="RETAIL">Retail</option>
              <option value="WHOLESALE">Wholesale</option>
              <option value="SERVICE">Service Business</option>
              <option value="RESTAURANT">Restaurant / Cafe</option>
              <option value="PHARMACY">Pharmacy</option>
              <option value="OTHER">Other</option>
            </select>
          </div>

          {/* MESSAGE */}
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-slate-400 sm:mb-2">
              Tell us about your business
              <span className="ml-1 text-slate-600">(Optional)</span>
            </label>
            <textarea
              name="message"
              rows={3}
              maxLength={500}
              value={form.message}
              onChange={onChange}
              placeholder="What would you like to manage with Muyaz?"
              className="w-full resize-none rounded-xl border border-white/10 bg-slate-950 px-3.5 py-3 text-sm text-white outline-none placeholder:text-slate-600 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 sm:px-4"
            />
          </div>

          {/* ERROR */}
          {error && (
            <div className="rounded-xl border border-red-500/20 bg-red-500/10 p-3">
              <p className="text-center text-xs font-medium text-red-400">
                {error}
              </p>
            </div>
          )}

          {/* SUCCESS */}
          {success && (
            <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/10 p-3">
              <p className="text-center text-xs font-medium text-emerald-400">
                {success}
              </p>
            </div>
          )}

          {/* SUBMIT */}
          <button
            type="submit"
            disabled={loading}
            className="
              flex w-full min-h-[48px] items-center justify-center gap-2
              rounded-xl bg-emerald-600 px-4 py-3.5 text-sm font-bold text-white
              shadow-lg shadow-emerald-600/20 transition hover:bg-emerald-500
              disabled:cursor-not-allowed disabled:opacity-60
            "
          >
            {loading ? (
              <>
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
                Sending Request...
              </>
            ) : (
              <>
                Request Free Demo
                <FaArrowRight />
              </>
            )}
          </button>

          {/* WhatsApp */}
          <button
            type="button"
            onClick={onWhatsApp}
            className="
              flex w-full min-h-[48px] items-center justify-center gap-2
              rounded-xl border border-[#25D366]/50 bg-[#25D366]/10
              px-4 py-3.5 text-sm font-bold text-[#25D366]
              transition hover:bg-[#25D366]/20
            "
          >
            <svg
              viewBox="0 0 24 24"
              className="h-5 w-5 fill-current"
              aria-hidden="true"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            Prefer WhatsApp instead
          </button>

          <p className="pb-1 text-center text-[10px] leading-relaxed text-slate-500 sm:text-[11px]">
            By submitting this form, you agree to be contacted about Muyaz
            Business OS.
          </p>
        </form>
      </div>
    </div>
  );
}
